import React from 'react';
import { DialogActions, Button } from '@mui/material';

interface DialogActionButtonsProps {
    isEditing: boolean;
    isLoading: boolean;
    isDeleting: boolean;
    onCancel: () => void;
    onDelete: () => void;
    onSave: () => void;
}

export const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({
    isEditing,
    isLoading,
    isDeleting,
    onCancel,
    onDelete,
    onSave
}) => {
    return (
        <DialogActions>
            <Button onClick={onCancel} disabled={isLoading || isDeleting}>
                Cancel
            </Button>
            {isEditing && (
                <Button
                    onClick={onDelete}
                    color="error"
                    disabled={isLoading || isDeleting}
                >
                    {isDeleting ? 'Deleting...' : 'Delete'}
                </Button>
            )}
            <Button
                onClick={onSave}
                variant="contained"
                disabled={isLoading || isDeleting}
            >
                {isLoading ? 'Saving...' : 'Save'}
            </Button>
        </DialogActions>
    );
};
